// DataTableComponent.js
import React from "react";
import DataTable from "@/components/dataTableComponents/DataTable";

const DataTableComponent = ({
  displayedRows,
  columns,
  page,
  rowsPerPage,
  totalRows,
  handlePageChange,
  handleRowsPerPageChange,
}) => (
  <DataTable
    rows={displayedRows}
    columns={columns}
    headerBgColor="#EAF5EE"
    checkboxSelection={false}
    headerCheckboxVisibility={false}
    page={page}
    rowsPerPage={rowsPerPage}
    totalRows={totalRows}
    onPageChange={handlePageChange}
    onRowsPerPageChange={handleRowsPerPageChange}
    getRowId={(row) => row.id} // Use unique ID
  />
);

export default DataTableComponent;
